// extracted by mini-css-extract-plugin
module.exports = {"report":"DashboardReport_report__26s0p","chart":"DashboardReport_chart__31oCM","chartLines":"DashboardReport_chartLines__3i94Q"};